import React, {useEffect, useState} from 'react'
import {useParams, Link} from 'react-router-dom'
import MuxPlayer from '@mux/mux-player-react'
import {sanity} from '../lib/sanity'

const VIDEO_QUERY = `*[
  _type == "video" &&
  slug.current == $slug
][0]{
  _id,
  title,
  description,
  "slug": slug.current,
  detailOrientation,
  "playbackId": coalesce(
    videoFile.asset->playbackId,
    videoFile.asset->data.playback_ids[0].id
  ),
  "status": videoFile.asset->status
}`

function VideoPage() {
  const {slug} = useParams()
  const [video, setVideo] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    sanity
      .fetch(VIDEO_QUERY, {slug})
      .then((result) => {
        setVideo(result)
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }, [slug])

  if (loading) return null

  if (!video) {
    return (
      <main className="min-h-screen px-8 py-24 text-[#5757fd]">
        <p>Video niet gevonden.</p>
      </main>
    )
  }

  const isHorizontal = video.detailOrientation === 'horizontal'

  return (
    <main className="min-h-screen overflow-x-hidden px-4 pb-20 pt-24 text-[#5757fd] md:px-8">
      {isHorizontal ? (
        <section className="mx-auto w-full max-w-6xl overflow-hidden rounded-[2.5rem] bg-white p-5 sm:rounded-[4rem] sm:p-6 md:p-10 lg:p-14">
          <Link
            to="/videos"
            className="mb-8 inline-flex w-fit rounded-full bg-[#f3f2ff] px-6 py-2 text-sm font-sans_bold text-[#5757fd] hover:text-[#5757fd]/80"
          >
            ← Alle videos
          </Link>
  
          <div className="aspect-video w-full overflow-hidden rounded-[2rem] bg-[#5757fd]">
            {video.playbackId ? (
              <MuxPlayer
                playbackId={video.playbackId}
                streamType="on-demand"
                accentColor="#5757fd"
                metadata={{
                  video_title: video.title,
                }}
                className="h-full w-full"
                style={{
                  width: '100%',
                  height: '100%',
                  '--media-object-fit': 'cover',
                  '--media-object-position': 'center',
                }}
              />
            ) : (
              <div className="flex h-full w-full items-center justify-center bg-[#5757fd] p-8 text-center text-white">
                <p>Deze video is nog niet klaar om af te spelen.</p>
              </div>
            )}
          </div>
  
          <div className="mx-auto mt-10 max-w-4xl text-center md:mt-14">
            <h1
              lang="nl"
              className="w-full max-w-full font-sans_bold text-4xl leading-[0.95] tracking-tight [overflow-wrap:anywhere] hyphens-auto sm:text-5xl md:text-6xl lg:text-7xl"
            >
              {video.title}
            </h1>
  
            {video.description && (
              <p
                lang="nl"
                className="mx-auto mt-8 w-full max-w-2xl whitespace-pre-line font-sans text-xl leading-tight [overflow-wrap:anywhere] hyphens-auto"
              >
                {video.description}
              </p>
            )}
          </div>
        </section>
      ) : (
        <section className="mx-auto grid w-full max-w-6xl gap-8 overflow-hidden rounded-[2.5rem] bg-white p-5 sm:rounded-[4rem] sm:p-6 md:grid-cols-[360px_minmax(0,1fr)] md:gap-10 md:p-10 lg:grid-cols-[420px_minmax(0,1fr)] lg:p-14">
          <div className="relative mx-auto aspect-[9/16] w-full max-w-[320px] overflow-hidden rounded-[2rem] bg-[#5757fd] sm:max-w-[360px] md:mx-0">
            {video.playbackId ? (
              <MuxPlayer
                playbackId={video.playbackId}
                streamType="on-demand"
                accentColor="#5757fd"
                metadata={{
                  video_title: video.title,
                }}
                className="h-full w-full"
                style={{
                  width: '100%',
                  height: '100%',
                  '--media-object-fit': 'cover',
                  '--media-object-position': 'center',
                }}
              />
            ) : (
              <div className="flex h-full w-full items-center justify-center bg-[#5757fd] p-8 text-center text-white">
                <p>Deze video is nog niet klaar om af te spelen.</p>
              </div>
            )}
          </div>
  
          <div className="flex min-w-0 max-w-full flex-col justify-center overflow-hidden">
            <Link
              to="/videos"
              className="mb-8 w-fit rounded-full bg-[#f3f2ff] px-6 py-2 text-sm font-sans_bold text-[#5757fd] hover:text-[#5757fd]/80"
            >
              ← Alle videos
            </Link>
  
            <h1
              lang="nl"
              className="w-full max-w-full font-sans_bold text-4xl leading-[0.95] tracking-tight [overflow-wrap:anywhere] hyphens-auto sm:text-5xl md:text-6xl lg:text-7xl"
            >
              {video.title}
            </h1>
  
            {video.description && (
              <p
                lang="nl"
                className="mt-8 w-full max-w-2xl whitespace-pre-line font-sans text-xl leading-tight [overflow-wrap:anywhere] hyphens-auto"
              >
                {video.description}
              </p>
            )}
          </div>
        </section>
      )}
    </main>
  )
}

export default VideoPage